import React, { useState, useEffect, useRef } from "react";
import { Collapse, Table } from "antd";
// import moment from "moment";
import { FormatDateTime } from "../../../utility/format";
import Api from "../../../../services/ServiceApi";

const { Panel } = Collapse;
export default function Impacttable({ locale, language, data }) {
  const rawData = JSON.parse(data);
  const unmounted = useRef(false);
  const [dataTable, setdataTable] = useState([]);
  const [factUpdate, setfactUpdate] = useState(false);
  useEffect(() => {
    if (rawData && rawData.length > 0) {
      rawData.map((datas, index) => {
        const objkey = Object.keys(datas)[0];
        if (datas[objkey]?.table !== undefined) {
          setdataTable(datas[objkey]?.table.data);
          setfactUpdate(true);
        }
      });
    }
    return () => {
      unmounted.current = true;
    };
  }, []);
  const columns = [
    {
      title: "Impact",
      dataIndex: "Impact_ID",
      key: "Impact_ID",
      width: 70,
    },
    {
      title: "Circuit ID",
      dataIndex: "Circuit_ID",
      key: "Circuit_ID",
      width: 80,
    },
    {
      title: "Circuit Name",
      dataIndex: "Circuit_Name",
      key: "Circuit_Name",
      width: 150,
    },
    {
      title: "Customer ID",
      dataIndex: "Cust_ID",
      key: "Cust_ID",
      width: 80,
    },
    {
      title: "Customer Name",
      dataIndex: "Customer_Name",
      key: "Customer_Name",
      width: 150,
    },
    {
      title: "Alarm",
      dataIndex: "Alarm",
      key: "Alarm",
      width: 100,
    },
    {
      title: "Card Type",
      dataIndex: "Card_Type",
      key: "Card_Type",
      width: 90,
    },
    {
      title: "DT Down",
      dataIndex: "",
      key: "",
      width: 100,
      render: (Item) => (
        <>
          <FormatDateTime text={Item.D_Down} format="dmy"></FormatDateTime>{" "}<FormatDateTime text={Item.T_Down} format="Hm"></FormatDateTime>
        </>
      ),
    },
    {
      title: "DT Ins",
      dataIndex: "",
      key: "",
      width: 100,
      render: (Item) => (
        <>
          {Item.D_Ins ? <><FormatDateTime text={Item.D_Ins} format="dmy"></FormatDateTime> {" "} <FormatDateTime text={Item.D_Ins} format="Hm"></FormatDateTime></> : ""}
        </>
      ),
    },


    

    // {
    //   title: "Node_ID",
    //   dataIndex: "Node_ID",
    //   key: "Node_ID",
    //   width: 80,
    // },
    // {
    //   title: "Interface",
    //   dataIndex: "Interface",
    //   key: "Interface",
    //   width: 120,
    // },
    // {
    //   title: "Slave",
    //   dataIndex: "Slave",
    //   key: "Slave",
    //   width: 120,
    // },
    // {
    //   title: "Trunk_ID",
    //   dataIndex: "Trunk_ID",
    //   key: "Trunk_ID",
    //   width: 120,
    // },
    // {
    //   title: "Trunk_Name",
    //   dataIndex: "Trunk_Name",
    //   key: "Trunk_Name",
    //   width: 120,
    // },
    // {
    //   title: "Unit",
    //   dataIndex: "Unit",
    //   key: "Unit",
    //   width: 120,
    // },
  ];

  return (
    <>
      <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
        <Panel
          header={
            <>
              <img
                src={Api.absoluteUrl("/icon/asset_layer.svg")}
                alt={factUpdate ? language[locale]["impact_table"] : null}
                title={factUpdate ? language[locale]["impact_table"] : null}
              />
              <h4>{factUpdate ? language[locale]["impact_table"] : null}</h4>
            </>
          }
          key="1"
        >
          <Table
            pagination={false}
            scroll={{ /*y: 400,*/ x: 600 }}
            tableLayout="fixed"
            columns={columns}
            dataSource={dataTable}
            className=""
            rowClassName=""
          ></Table>
        </Panel>
      </Collapse>
    </>
  );
}
